import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=fd2d73ca&scoped=true"
import script from "./customerInfo.vue?vue&type=script&lang=js"
export * from "./customerInfo.vue?vue&type=script&lang=js"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=fd2d73ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2d73ca",
  null
  
)

export default component.exports